export const FILTRE_DYNAMIQUE_VIDE = 'Sélectionner un filtre';
// Constant a supprimer quand  il y auara un autre export
// pb eslint
export const test = '';



// WEBPACK FOOTER //
// ./src/components/creationOpportunite/configuration/filtresConf.js